// Dashboard · Iframe — placeholder. Future home for geoVINUM Iframe
// analytics (embeds, hits, referrers) and the admin UI to manage
// customer embed configurations.
import { Construction } from "lucide-react";

const AdminDashboardIframePage = () => {
  return (
    <div className="max-w-4xl mx-auto p-6" data-testid="admin-dashboard-iframe">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-widest text-[color:var(--gv-pink)] mb-1">Dashboard</div>
        <h1 className="font-display text-3xl text-[color:var(--gv-ink)]">Iframe geoVINUM</h1>
      </div>

      <div className="bg-white border border-[color:var(--gv-line)] rounded-[6px] p-10 text-center">
        <Construction size={36} className="mx-auto text-[color:var(--gv-pink)]/70 mb-4" />
        <div className="font-display text-xl text-[color:var(--gv-ink)] mb-2">À venir</div>
        <p className="text-[13.5px] text-[color:var(--gv-ink)]/60 max-w-md mx-auto">
          Ce module centralisera prochainement les analytics d'embed geoVINUM Iframe :
          nombre de vues, principaux domaines référents, et administration des clients embarqués.
        </p>
      </div>
    </div>
  );
};

export default AdminDashboardIframePage;
